module.exports = __webpack_public_path__ + "static/media/WhitneyCond-Semibold.b1ecc30a.otf";